import { useState } from 'react';
import styled from 'styled-components';
import { PreloadedImage } from './PreloadedImage';
import { LinkContained } from './form/LinkContained';
import { useQuery } from '@apollo/client';
import { GET_ILLUSTRATED_PAYMENT } from '../graphql/queries';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    imageId: string;
    paymentId: string;
    locale: string;
}

const Container = styled.div`
	display: grid;
	grid-gap: 48px;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
`;

const Heading = styled.h2`
	${({ theme }) => theme.typography.heading4};
	margin-bottom: 8px;
`;

const Description = styled.div`
`;

const Price = styled.div`
    margin: 8px 0 24px;
    color: #3b8f7b;
	${({ theme }) => theme.getTypography('h4')};
    text-align: center;
`;

const Image = styled(PreloadedImage)`
	display: block;
	width: 100%;
`;

const Texts = styled.div`
    display: grid;
    grid-gap: 24px;
`;

const BuyButton = styled(LinkContained)`
    justify-self: center;
	display: block;
	min-width: 64px;
    margin-bottom: 16px;
`;

export const IllustratedPayment = ({ imageId, paymentId, locale, className }: Props) => {
    const { data, loading } = useQuery(GET_ILLUSTRATED_PAYMENT, { variables: { imageId, paymentId, locale } });

    return loading
        ? <div>loading</div>
        : <Container className={className}>
            <Image {...data.preloadedImage} />
            <Texts>
                <Heading>{data.payment.heading}</Heading>
                <Description dangerouslySetInnerHTML={{ __html: data.payment.descriptionHTML }} />
                <Price>{data.payment.price} zł</Price>
                <BuyButton href={data.payment.url} target="_blank">{data.payment.label}</BuyButton>
            </Texts>
        </Container>
};